// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__054eR","video_container":"Video_video_container__SJIN3","play_button_container":"Video_play_button_container__0he3H"};